import { defineComponent as _defineComponent } from 'vue'
import { Typo, TypoVariant, Button, ProgressBar } from '@travelata-libs/ui-kit';
  import { computed, ref } from 'vue';
  import { MAX_ASPECTS_COLLAPSED, MAX_ASPECTS_EXPANDED, REVIEW_SUMMARY_OVERVIEW_ANCHOR_ID } from '../config';
  import { PRAISED_TITLE, CAVEATS_TITLE, addMentionsCaption, getReviewsCaption } from '../lib/reviewSummaryLabels';
  import { useReviewSummary } from '../lib/useReviewSummary';

  interface ReviewSummaryOverviewEmits {
    (e: 'expand-criteria'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewSummaryOverview',
  emits: ["expand-criteria"],
  setup(__props, { emit }: { emit: ({
    (e: 'expand-criteria'): void;
  }), expose: any, slots: any, attrs: any }) {

  

  const { hasSummary, praised, caveats, hotelSummary, reviewsTotal, period } = useReviewSummary();

  const isExpanded = ref(false);

  const toggleExpanded = () => {
    if (!isExpanded.value) {
      emit('expand-criteria');
    }
    isExpanded.value = !isExpanded.value;
  };

  const reviewsCaption = computed(() => getReviewsCaption(reviewsTotal.value, period.value));

  const visibleLimit = computed(() => (isExpanded.value ? MAX_ASPECTS_EXPANDED : MAX_ASPECTS_COLLAPSED));

  const praisedItems = computed(() => praised.value.map((aspect) => addMentionsCaption(aspect, reviewsTotal.value)));
  const caveatsItems = computed(() => caveats.value.map((aspect) => addMentionsCaption(aspect, reviewsTotal.value)));

  const visiblePraised = computed(() => praisedItems.value.slice(0, visibleLimit.value));
  const visibleCaveats = computed(() => caveatsItems.value.slice(0, visibleLimit.value));

  const isToggleVisible = computed(
    () => praised.value.length > MAX_ASPECTS_COLLAPSED || caveats.value.length > MAX_ASPECTS_COLLAPSED,
  );
  const toggleLabel = computed(() => (isExpanded.value ? 'Скрыть' : 'Показать все критерии'));

return { __sfc: true,emit, hasSummary, praised, caveats, hotelSummary, reviewsTotal, period, isExpanded, toggleExpanded, reviewsCaption, visibleLimit, praisedItems, caveatsItems, visiblePraised, visibleCaveats, isToggleVisible, toggleLabel, Typo, TypoVariant, Button, ProgressBar, REVIEW_SUMMARY_OVERVIEW_ANCHOR_ID, PRAISED_TITLE, CAVEATS_TITLE }
}

})